var _path, _circle, _path2, _path3, _line, _path4, _line2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBloodPressure(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 333.3333,
    d: "M4.8,4.8h12.2c1.7,0,3,1.4,3,3V17c0,1.7-1.3,3-3,3H4.8l0,0V4.8L4.8,4.8z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 333.3333,
    cx: 29.6,
    cy: 11.7,
    r: 5.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 333.3333,
    d: "M14.4,18.6V20c0,3.1,2.5,5.5,5.5,5.5c0,0,0,0,0,0h4.2c3,0,5.5-2.5,5.5-5.5v-8.3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 333.3333,
    d: "M26.9,29.7H31c1.5,0,2.8,1.2,2.8,2.8l0,0c0,1.5-1.2,2.8-2.8,2.8h-4.1c-1.5,0-2.8-1.2-2.8-2.8l0,0C24.1,30.9,25.3,29.7,26.9,29.7z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 333.3333,
    x1: 36.5,
    y1: 32.4,
    x2: 33.8,
    y2: 32.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 333.3333,
    d: "M7.5,18.6v2.8c0,6.1,5,11.1,11.1,11.1h5.5"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 333.3333,
    x1: 10.3,
    y1: 4.8,
    x2: 10.3,
    y2: 15.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBloodPressure);
export default __webpack_public_path__ + "static/media/BloodPressure.ca672d2f1d0b7c82b63d84068384d694.svg";
export { ForwardRef as ReactComponent };